export enum QuotationStateEnums {
  open = 1,
  approved = 2,
  refused = 3,
  closed = 4,
}

export enum QuotationTypesEnums {
  rental = 1,
  newSale = 2,
  usedSale = 3,
  service = 4,
  maintenance = 5,
}

export enum QuotationDetailEnums {
  UnitValue = 1,
  Subtotal = 2,
}

export enum PrintQuotationEnums {
  withBreakdown = 1,
  withoutBreakdown = 0,
}

export enum ImagesQuotationDetailEnums {
  image1 = 1,
  image2 = 2,
  image3 = 3,
  image4 = 4
}

